import classNames from 'classnames';
import Decimal from 'decimal.js';
import { useEffect, useState } from 'react';

import { implog } from '@/api/implog';
import icon_checked from '@/assets/icon/icon_checked.webp';
// import topBg from '@/assets/modal/pochan_bg.webp';
import Button from '@/components/button';
import { CloseOutLine } from '@/components/icons/icons';
import BlurryLoadingImage from '@/components/progressive-img';
import { getQueryParam } from '@/hooks/useParam';
import useRecharge from '@/hooks/useRecharge';
import { gameStore } from '@/stores/game';
import { modalStore } from '@/stores/modal';
import { exitFullscreen } from '@/utils/fullscreen';
import Storage from '@/utils/Storage';

import styles from './styles.module.less';

const PochanHorizontalModal = () => {
  const { pochanConfigList } = modalStore;
  const [amount, setAmount] = useState(0);
  // 判断 横竖屏

  useEffect(() => {
    implog('pochan_ingame_modal_show');
  }, []);

  useEffect(() => {
    if (pochanConfigList?.length > 0) {
      setAmount(pochanConfigList[0].payfee);
    }
  }, [pochanConfigList]);

  // useLayoutEffect(() => {
  //   const handleFullscreenChange = () => {
  //     const currentFullscreenElement = document.fullscreenElement;
  //     setContainer(currentFullscreenElement);
  //   };
  //   handleFullscreenChange();

  //   window.addEventListener('fullscreenchange', handleFullscreenChange);

  //   return () => {
  //     window.removeEventListener('fullscreenchange', handleFullscreenChange);
  //   };
  // }, []);

  useEffect(() => {
    exitFullscreen();
  }, []);
  const { runRecharge } = useRecharge();
  return (
    <div className={styles.maskcontainer}>
      <div className={styles.container}>
        <div
          className={styles.close__container}
          onClick={() => {
            modalStore.closeModal('pochan-horizontal-modal');
          }}
        >
          <CloseOutLine className={styles.close} />
        </div>
        <BlurryLoadingImage
          loading="lazy"
          src={`${window?.imgPrefix || ''}/img/modal/pochan_bg.webp`}
          className={styles.bg}
        />
        <div className={styles.head}>Exclusive offers for you</div>
        <div className={styles.main}>
          <div className={styles.table}>
            <div className={styles.thead}>
              <div>Deposit</div>
              <div>Bonus</div>
              <div>Total Received</div>
            </div>

            {pochanConfigList.map(({ rid, payfee, payadd, sendamount }) => (
              <div key={rid} className={styles.item}>
                <div
                  className={classNames(styles.tbody_tr, { [styles.active_tr]: payfee === amount })}
                  onClick={() => {
                    setAmount(payfee);
                  }}
                >
                  <div>$ {payfee}</div>
                  <div style={{ whiteSpace: 'nowrap' }}>+{payadd}%</div>
                  <div className={styles.last_child}>{Decimal.add(payfee, sendamount).toNumber()}</div>
                  <div className={styles.checked}>
                    <BlurryLoadingImage loading="lazy" src={icon_checked} alt="" />
                  </div>
                </div>
                <Button
                  type="success"
                  className={styles.btn}
                  onClick={() => {
                    const playgame = Storage.get('PLAY_GAME');
                    const serverid = getQueryParam('serverid', playgame);
                    const params: any = {
                      amount: payfee,
                      cztype: 'pochan',
                      serverid,
                      from: 1
                    };
                    if (serverid) params.serverid = serverid;
                    runRecharge({
                      amount: payfee,
                      from: 1,
                      serverid: serverid || '',
                      cztype: 'pochan'
                    });
                    implog('pochan_ingame_modal_click', payfee.toString());
                    gameStore.hideGame();
                  }}
                >
                  Pay ${payfee}
                </Button>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.tips}>Deposit any amount and get a bonus $0.5-1</div>
      </div>
    </div>
  );
};

export default PochanHorizontalModal;
